@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}

@keyframes circle-animation {
  0%,
  25% {
    transform: rotate(0);
    stroke-dashoffset: 280;
  }

  50%,
  75% {
    transform: rotate(45deg);
    stroke-dashoffset: 75;
  }

  100% {
    transform: rotate(360deg);
    stroke-dashoffset: 280;
  }
}

.loadingSpinner {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100px;
  margin: auto;
  animation: rotate 2s linear infinite;

  &.white {
    color: #fff;
  }

  &.blue {
    color: var(--dark-blue-500);
  }
}

.loadingCircle {
  display: block;
  transform-origin: 50% 50%;
  animation: circle-animation 1.4s ease-in-out infinite both;
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke: currentColor; // <-- allows us to set color at the SVG level (to be more semantic)
  fill: transparent;
}
